import React, { useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";
import dashboardImg from "../../assets/images/Dashboard.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import CourseCard from "../../components/LandingPageCourseCard/LandingPageCourseCard";
import courseImg from "../../assets/images/course-img.jpg";
import courseImg2 from "../../assets/images/course-img-2.png";
import courseImg3 from "../../assets/images/course-img-3.jpg";
import createrImg from "../../assets/images/creator-img.jpg";
import FilterCourse from "../../components/courseFilter/courseFilter";
import FaqsAccordion from "../../components/faqsAccordion/faqsAccordion";
import TestimonialSlider from "../../components/testimonialSlider/testimonialSlider";
import FetureSection from "../../components/fetureSection/fetureSection";
import LearningSection from "../../components/learningSection/learningSection";
import AboutTabsContent from "../../components/aboutTabContent/aboutTabContent";

const LandingPage = () => {
  useEffect(() => {
  AOS.init({
    duration: 1200,
    once: false,
    easing: 'ease-in-out',
  });
}, []);
  const CoursesData = [
    {
      id: 1,
      courseImg: courseImg,
      courseTag: "FRONTEND",
      courseTitle:
        "Beginner’s Guide to becoming a professional frontend developer",
      courseCreatorImg: createrImg,
      courseCreatorName: "John Murphy",
      courseCreatorStack: "Software Developer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
    {
      id: 2,
      courseImg: courseImg2,
      courseTag: "BACKEND",
      courseTitle: "Mastering Node.js for scalable backend systems",
      courseCreatorImg: createrImg,
      courseCreatorName: "Sarah Lee",
      courseCreatorStack: "Backend Engineer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
    {
      id: 3,
      courseImg: courseImg3,
      courseTag: "FULLSTACK",
      courseTitle: "Complete Fullstack Developer Bootcamp 2025",
      courseCreatorImg: createrImg,
      courseCreatorName: "David Kim",
      courseCreatorStack: "Fullstack Engineer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
    {
      id: 4,
      courseImg: courseImg,
      courseTag: "UI/UX",
      courseTitle: "UI/UX Design Principles for Developers",
      courseCreatorImg: createrImg,
      courseCreatorName: "Emily Watson",
      courseCreatorStack: "Product Designer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
    {
      id: 5,
      courseImg: courseImg2,
      courseTag: "MOBILE",
      courseTitle: "React Native Essentials for Mobile App Development",
      courseCreatorImg: createrImg,
      courseCreatorName: "James Nolan",
      courseCreatorStack: "Mobile Developer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
    {
      id: 6,
      courseImg: courseImg3,
      courseTag: "DEVOPS",
      courseTitle: "Introduction to DevOps and CI/CD",
      courseCreatorImg: createrImg,
      courseCreatorName: "Priya Desai",
      courseCreatorStack: "DevOps Engineer",
      studentImage: [
        {
          Image: courseImg2,
        },
        {
          Image: courseImg,
        },
        {
          Image: courseImg3,
        },
      ],
    },
  ];
  const categoriesList = [
    "FRONTEND",
    "BACKEND",
    "FULLSTACK",
    "UI/UX",
    "MOBILE",
    "DEVOPS",
  ];
  // FAQs Array
  const InitialFaqItems = [
    {
      id: 1,
      question: "Is there a free trial available?",
      answer:
        "Yes, You Can Try Us For Free For 30 Days. If You Want, We'll Provide You With A Free, Personalized 30-Minute Onboarding Call To Get You Up And Running As Soon As Possible.",
      show: true,
    },
    {
      id: 2,
      question: "Can I change my plan later?",
      answer:
        "Yes, you can change your plan anytime from your account settings.",
      show: false,
    },
    {
      id: 3,
      question: "What is your cancellation policy?",
      answer:
        "You can cancel your subscription at any time. Your access will remain until the end of your billing period.",
      show: false,
    },
    {
      id: 4,
      question: "How does billing work?",
      answer: "We bill monthly or annually depending on the plan you select.",
      show: false,
    },
    {
      id: 5,
      question: "Can other info be added to an invoice?",
      answer:
        "Yes, you can include extra details like tax info or company address in your invoice settings.",
      show: false,
    },
    {
      id: 6,
      question: "How do I change my account email?",
      answer:
        "Go to your profile settings and update your email address. A confirmation will be sent to the new address.",
      show: false,
    },
  ];
  const stepsData1 = [
    {
      id: 1,
      title: "Choose Your Learning Path",
      content: `Choose your learning path and delve into the fascinating balance of nature and nurture. Discover the colorful journey of life, where every twist reveals fresh chances for growth and connection. Allow the flow of your experiences to lead you toward a harmonious destination.`,
    },
    {
      id: 2,
      title: "Engage & Earn",
      content: `Participate actively in your courses and projects to gain rewards and recognition. Your commitment opens doors to new opportunities.`,
    },
    {
      id: 3,
      title: "Get Certified",
      content: `Complete milestones to earn certificates that validate your skills. Boost your career with proof of your learning achievements.`,
    },
    {
      id: 4,
      title: "Apply Your Skills",
      content: `Put your knowledge into action in real-world scenarios. Apply your skills to meaningful projects, internships, or freelance work.`,
    },
  ];
  const stepsData2 = [
    {
      id: 1,
      title: "For Learners",
      content: `Discover the dynamic interplay of technology and artistry in our platform. We aim to transform the way users interact with digital content, ensuring seamless navigation and engaging visuals that captivate and inspire.`,
    },
    {
      id: 2,
      title: "For Businesses",
      content: `Participate actively in your courses and projects to gain rewards and recognition. Your commitment opens doors to new opportunities.`,
    },
    {
      id: 3,
      title: "For Educators & Mentors",
      content: `Complete milestones to earn certificates that validate your skills. Boost your career with proof of your learning achievements.`,
    },
    {
      id: 4,
      title: "For the Community",
      content: `Put your knowledge into action in real-world scenarios. Apply your skills to meaningful projects, internships, or freelance work.`,
    },
  ];
  const [activeCategory, setActiveCategory] = useState("ALL");
  return (
    <>
      <div className="herro-wrapper bg-gradient-theme overflow-hidden">
        <header className="herro-header mx-auto text-center">
          <h2
            className="intro-text theme-color fw-bold ad-heading-03 mb-16"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Introducing EGWB
          </h2>
          <h1
            className="main-heading fw-bold mb-20"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Empowering Learning, Gaming, And Wellness In A Blockchain-Driven
            Ecosystem
          </h1>
          <p
            className="sub-text text-black mb-20 mb-sm-30 mb-lg-40"
            data-aos="fade-up"
            data-aos-delay="900"
          >
            A revolutionary platform blending education, gaming, and wellness to
            create an engaging and community-driven learning experience.
          </p>
          <div
            className="header-buttons d-flex justify-content-center mb-30 mb-sm-40 mb-md-50 flex-wrap gap-3"
            data-aos="fade-up"
            data-aos-delay="1200"
          >
            <Link to={"/user-type"} className="btn btn-primary px-32 py-13 no-shadow">
              Sign Up for Beta
            </Link>
            <Link to={"/"} className="btn btn-light no-shadow">Contact us</Link>
          </div>
          <div
            className="dashboard-img-wrapper mx-auto p-22"
            data-aos="zoom-in"
            data-aos-delay="1500"
          >
            <LazyLoadImage
              src={dashboardImg}
              alt="Dashboard Image"
              className="img-fluid"
              effect="blur"
            />
          </div>
        </header>
      </div>
      <LearningSection />
      <div className="course-section bg-gradient-theme overflow-hidden">
        <div className="container custom-container">
          <div className="course-section-content text-center mx-auto mb-50">
            <h1
              className="mb-17 text-black fw-bold web-heading-01"
              data-aos="fade-up"
            >
              Discover a World of Courses!
            </h1>
            <p
              className="fw-normal mb-0 ah-text-xl"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Dive into our extensive and diverse range of courses, meticulously
              designed to inspire and empower you to learn something new and
              exciting every single day!
            </p>
          </div>
          <FilterCourse
            categories={categoriesList}
            onFilterChange={setActiveCategory}
          />
          <CourseCard
            filtered={true}
            active={activeCategory}
            CoursesList={CoursesData}
          />
          <div
            className="text-center mt-20 mt-sm-30 mt-md-40 mt-lg-50"
            data-aos="zoom-in"
            data-aos-delay="600"
          >
            <Link to={""} className="btn btn-primary no-shadow">
              View all
            </Link>
          </div>
        </div>
      </div>
      <FetureSection />
      <div className="about-tabs-section overflow-hidden">
        <div className="container custom-container mb-50">
          <div className="about-content">
            <h2 className="fw-bold web-heading-01 mb-10" data-aos="fade-up">
              How Does It Work?
            </h2>
            <p
              className="ah-text-xl fw-normal mb-30"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Choose your learning path and delve into the fascinating balance
              of nature and nurture. Discover the colorful journey of life,
              where every twist reveals fresh chances for growth and connection.
            </p>
          </div>
          <AboutTabsContent steps={stepsData1} />
        </div>
        <div className="tab-two mt-50">
          <div className="container custom-container">
            <div className="about-content ms-auto">
              <h2 className="fw-bold web-heading-01 mb-10" data-aos="fade-up">
                Community Benefits
              </h2>
              <p
                className="ah-text-xl fw-normal mb-30"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Explore the essence of creativity and innovation in our latest
                project, where we delve into the intricacies of design and
                functionality. Join us as we embark on a journey to enhance user
                experiences and foster collaboration.
              </p>
            </div>
          </div>
          <AboutTabsContent steps={stepsData2} />
        </div>
      </div>
      <div className="graduates-section overflow-hidden">
        <h1 className="web-heading-01 fw-bold text-center mb-40" data-aos="fade-up">
          Hear from our path graduates
        </h1>
        <div className="container overflow-visible custom-container">
          <TestimonialSlider />
        </div>
      </div>

      <div className="faqs-section overflow-hidden">
        <div className="container custom-container">
          <div className="faqs-content text-center mb-50">
            <h1 className="web-heading-01 fw-bold text-black mb-31" data-aos="fade-up">
              Frequently asked questions
            </h1>
            <p className="fw-normal ah-text-xl" data-aos="fade-up" data-aos-delay="300">
              Everything you need to know about the product and billing.
            </p>
          </div>
          <FaqsAccordion FaqItemsList={InitialFaqItems} />
        </div>
      </div>
    </>
  );
};

export default LandingPage;
